import { DataTable } from "primereact/datatable";
import { CaseStatus } from "../../constants";
import { useCallback, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import {
  useClients,
  //useGetInsurance,
  useRequirementTypes,
} from "../../hooks/queries";
import { Column } from "primereact/column";
//import { currencyFormat, formatCi, formatFullNumber } from "../../utils";
import { formatCi, formatFullNumber } from "../../utils";
import StatusTag from "../StatusTag";
import { Link } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { PaginatorTemplate } from "../../Layout/Paginator/PaginatorTemplate";
import { FilterMatchMode } from "primereact/api";

/**
 * Template to format the amount of a case
 */

//const amountBodyTemplate = (rowData) => {
  //return currencyFormat(rowData.amount ?? 0);
//};

/**
 * Template to show the status of a case
 */
const statusBodyTemplate = (rowData) => <StatusTag value={rowData.status} />;

const caseStatusArray = Object.entries(CaseStatus.labels).map(
  ([key, item]) => ({
    label: item,
    value: key,
  })
);

const statusItemTemplate = (option) => <StatusTag value={option?.value} />;

const statusRowFilterTemplate = (options) => (
  <Dropdown
    value={options.value}
    options={caseStatusArray}
    onChange={(e) => {
      options.filterApplyCallback(e.value);
    }}
    itemTemplate={statusItemTemplate}
    placeholder="Seleccionar status"
    className="p-column-filter min-w-min"
    showClear
  />
);

/**
 * Generic medical cases table
 * @param {object} props
 * @param {import("../../services/medicalCases").MedicalCase[]} props.cases
 * @param {boolean} props.isLoading
 * @param {number} props.totalCases
 * @param {[object, function]} props.lazyFiltersResult
 * @param {[object, function]} props.lazyStateResult
 * @param {[number, function]} props.pageSizeResult
 * @param {React.ReactNode} props.tableHeader
 * @param {string} props.viewCasePrefix
 */
export default function MedicalCaseTable({
  cases,
  isLoading,
  totalCases,
  lazyFiltersResult,
  lazyStateResult,
  pageSizeResult,
  tableHeader = null,
  viewCasePrefix = "",
}) {
  const clientsQuery = useClients(false);
  const requirementTypesQuery = useRequirementTypes();
  // const { data: insurance } = useGetInsurance();

  const [selectedRows, setSelectedRows] = useState(null);

  const [pageSize, setPageSize] = pageSizeResult;
  const [lazyFilters, setLazyFilters] = lazyFiltersResult;
  const [lazyState, setLazyState] = lazyStateResult;

  const onPageChange = (e) => {
    setPageSize(e.rows);
    setLazyState({ ...lazyState, first: e.first, page: e.page + 1 });
  };

  const [filters] = useState({
    // global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_client: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.sex": { value: null, matchMode: FilterMatchMode.EQUALS },
    requirement_type_names: { value: null, matchMode: FilterMatchMode.EQUALS },
    "holder_.ci": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.ci": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.name": { value: null, matchMode: FilterMatchMode.CONTAINS },
    requirement_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.birthdate": { value: null, matchMode: FilterMatchMode.CONTAINS },
    diagnosis_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    medical_center_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subsidiary_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.phone": { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState(event);
    setLazyFilters({
      ...lazyFilters,
      subsidiary__company_client: event.filters.company_client.value,
      company_client: event.filters.company_client.value,
      status: event.filters.status.value,
      id_parent: event.filters.id.value,
      // id__contains: event.filters.id.value,
      holder__ci__icontains: event.filters["holder_.ci"].value,
      patient__ci__icontains: event.filters["patient_.ci"].value,
      patient_name__icontains: event.filters["patient_.name"].value,
      medical_center__name__icontains: event.filters.medical_center_name.value,
      requirements__requirement__type_requirement:
        event.filters.requirement_type_names.value,
    });
  };

  /**
   * Dropdown to filter case client
   */
  const clientRowFilterTemplate = useCallback(
    (options) => (
      <Dropdown
        value={options.value}
        loading={clientsQuery.isLoading}
        disabled={clientsQuery.isLoading}
        options={clientsQuery.data ?? []}
        optionLabel="name"
        optionValue="id"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        placeholder="Seleccionar cliente"
        className="p-column-filter min-w-min"
        showClear
      />
    ),
    [clientsQuery.data, clientsQuery.isLoading]
  );

  /**
   * Dropdown to filter requirement types
   */
  const requirementTypeFilterTemplate = useCallback(
    (options) => (
      <Dropdown
        value={options.value}
        loading={requirementTypesQuery.isLoading}
        disabled={requirementTypesQuery.isLoading}
        options={requirementTypesQuery.data ?? []}
        optionValue="id"
        optionLabel="name"
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Seleccionar tipo"
        className="p-column-filter min-w-min"
        showClear
        filter
        style={{ maxWidth: "10rem" }}
      />
    ),
    [requirementTypesQuery.isLoading, requirementTypesQuery.data]
  );

  /**
   * Template to show the action button to view case details
   */
  const ViewDetailBodyTemplate = useCallback(
    (row) => (
      <Link to={`${viewCasePrefix}${row.id}`} className="p-button text-sm p-2">
        <span className="p-button-icon p-button-icon-left pi pi-eye"></span>
        <span className="p-button-label">Ver</span>
      </Link>
    ),
    [viewCasePrefix]
  );

  return (
    <>
      <DataTable
        value={cases}
        dataKey="id"
        size="small"
        loading={isLoading}
        emptyMessage="No se hallaron casos."
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={(e) => setSelectedRows(e.value)}
        stripedRows
        scrollable
        removableSort
        filters={filters}
        onFilter={onFilter}
        rowClassName={(rowData) => ({
          "bg-green-300":
            rowData.prioritized &&
            [CaseStatus.PENDIENTE, CaseStatus.RESCHEDULED].includes(
              rowData.status
            ),
        })}
        header={tableHeader}
      >
        <Column
          field="company_client"
          header="Cliente"
          filter
          filterPlaceholder="Buscar por Cliente"
          filterElement={clientRowFilterTemplate}
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
        />

        <Column
          field="created"
          header="Fecha"
          dataType="date"
          filterPlaceholder="Buscar por fecha"
        />

        <Column
          field="service_id"
          header="Nro. Siniestro"
          filter
          filterPlaceholder="Buscar Nro. de Siniestro"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
        />

        <Column
          field="id"
          header="ID #"
          sortable
          filter
          body={(row) => {
            return row.parent_case_id ?? row.id;
          }}
          filterPlaceholder="Buscar por Nro. de Caso"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
        />

        <Column
          field="holder_.ci"
          header="CI Titular"
          filter
          filterPlaceholder="Buscar por Titular"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
          body={(row) => formatCi(row.holder_.ci)}
        />

        <Column
          field="patient_.ci"
          header="CI Paciente"
          filter
          filterPlaceholder="Buscar por CI Paciente"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
          body={(row) => formatCi(row.patient_.ci)}
        />

        <Column
          field="patient_.name"
          header="Nombre Paciente"
          filter
          filterPlaceholder="Buscar por Nombre"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
        />

        <Column
          field="patient_.phone"
          header="Teléfono Paciente"
          filter
          filterPlaceholder="Buscar por Teléfono"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
          body={(row) => formatFullNumber(row.patient_.phone)}
        />
        {/* 
        <Column
          field="requirement_type_names"
          header="Tipo de requerimiento"
          filter
          filterElement={requirementTypeFilterTemplate}
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
        />
          */}

        <Column
          header="Tipo de requerimiento"
          body={(rowData) => rowData.type_requirement_name || "-"} /// CAMBIO
          filter
          filterField="requirement_type_names"  // ← Aquí va el campo real de tus datos
          filterElement={requirementTypeFilterTemplate}
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
        /> 
        {/* 
        <Column
          field="requirement_names"
          header="Requerimiento"
          filter
          filterPlaceholder="Buscar por Requerimiento"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
          body={(row) =>
              row.requirements_name.slice(0, 60) +
              (row.requirements_name.length > 60 ? "..." : "")
            }
        />
        


        <Column
          field="amount"
          header={
            insurance?.name === "Vértice Seguros" ? "Monto REF" : "Monto (Bs.)"
          }
          filter
          filterPlaceholder="Buscar por Monto"
          showFilterMenu={false}
          body={amountBodyTemplate}
          bodyClassName="readable-cell"
          sortable
        />

        <Column
          field="diagnosis_name"
          header="Diagnóstico"
          filter
          filterPlaceholder="Buscar por Diagnóstico"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
        />
        */}
        <Column
          field="medical_center_name"
          header="Proveedor"
          filter
          filterPlaceholder="Buscar por Proveedor"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          bodyClassName="readable-cell"
        />

        <Column
          field="status"
          header="Status"
          showFilterMatchModes={false}
          showClearButton={false}
          showApplyButton={false}
          body={statusBodyTemplate}
          filter
          filterElement={statusRowFilterTemplate}
          frozen
          alignFrozen="right"
        />

        <Column
          header="Acción"
          body={ViewDetailBodyTemplate}
          frozen
          alignFrozen="right"
        />
      </DataTable>

      <Paginator
        first={lazyState.first}
        rows={pageSize}
        totalRecords={totalCases}
        template={PaginatorTemplate}
        onPageChange={onPageChange}
      />
    </>
  );
}
